import ValidatorFunctions from "../validation/ValidatorFunctions"

const refinementConfiguration = {
    namespaced: true,
    state:      {
        refinement: {},
        filetColor: {},
        decor:      {}
    },
    getters:    {
        hasFiletRefinement: (state, getters) => {
            if (getters.hasRefinement) {
                return state.refinement.getDescription() === 'mytw_conf_refinement_filet'
            }

            return false
        },

        hasDecorRefinement: (state, getters) => {
            if (getters.hasRefinement) {
                return state.refinement.getDescription() === 'mytw_conf_refinement_decor'
            }

            return false
        },

        hasRefinement: state => {
            return !ValidatorFunctions.isEmpty(state.refinement)
        },

        hasFiletColor: state => {
            return !ValidatorFunctions.isEmpty(state.filetColor)
        },

        hasDecor: state => {
            return !ValidatorFunctions.isEmpty(state.decor)
        }
    },
    mutations:  {
        updateRefinement: function (state, refinement) {
            state.refinement = refinement
        },

        updateFiletColor: function (state, filetColor) {
            state.filetColor = filetColor
        },

        updateDecor: function (state, decor) {
            state.decor = decor
        }
    }
}

export default refinementConfiguration
